import { render, staticRenderFns } from "./staIncome.vue?vue&type=template&id=0945eadc&scoped=true"
import script from "./staIncome.vue?vue&type=script&lang=js"
export * from "./staIncome.vue?vue&type=script&lang=js"
import style0 from "./staIncome.vue?vue&type=style&index=0&id=0945eadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945eadc",
  null
  
)

export default component.exports